import { Link } from 'react-router-dom';
import { announcementApi } from '../../api/client';
import { useApiQuery } from '../../hooks/useApiQuery';
import { Megaphone } from 'lucide-react';

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

export function AnnouncementsPage() {
  const { data, isLoading } = useApiQuery({
    queryKey: ['announcements'],
    queryFn: () => announcementApi.list(),
    refetchOnMount: 'always',
  });

  const announcements = data?.announcements || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <Megaphone className="w-8 h-8 text-primary-600" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Announcements</h1>
          <p className="text-gray-500">Platform news and updates</p>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
      ) : announcements.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <Megaphone className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p className="text-sm">No announcements yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {announcements.map((a) => (
            <Link
              key={a.id}
              to={`/announcements/${a.id}`}
              className="block bg-white rounded-xl border border-gray-200 p-5 hover:border-primary-300 hover:shadow-sm transition-all"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Megaphone className="w-4 h-4 text-primary-600" />
                </div>
                <div className="min-w-0">
                  <h2 className="font-semibold text-gray-900 truncate">{a.title}</h2>
                  <p className="text-xs text-gray-400 mt-0.5">{formatDate(a.created_at)}</p>
                  {a.preview && (
                    <p className="text-sm text-gray-600 mt-2 line-clamp-2">{a.preview}</p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
